import { render } from "./LogsPage.vue?vue&type=template&id=798c1d5b&scoped=true"
import script from "./LogsPage.vue?vue&type=script&lang=js"
export * from "./LogsPage.vue?vue&type=script&lang=js"

import "./LogsPage.vue?vue&type=style&index=0&id=798c1d5b&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-798c1d5b"]])

export default __exports__